import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HeaderPage from '~/components/HeaderPage';
import { ApplicationState } from '~/store';
import { personalRequest } from '~/store/ducks/MostrarInformacoesPessoais/actions';
import Categorias from './categorias';
import { Container } from './styles';

const MostrarInformacoesPessoais: React.FC = () => {
  const personalState = useSelector<ApplicationState, any>(
    state => state.mostrarInformacoesPessoais.data,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Mostrar informações pessoais | Portal LGPD';
    dispatch(personalRequest(1));
  }, [dispatch]);

  return (
    <Container>
      <HeaderPage pageTitle="Mostrar informações pessoais" />

      <div className="content">
        <Categorias personalData={personalState} />
      </div>
    </Container>
  );
};

export default MostrarInformacoesPessoais;
